import React, { useEffect } from "react";
import { IForm } from "../../../../types/form.type";
import ModalForm from "../../modal/ModalForm";
import { Stack } from "@mui/material";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { asyncPostData, asyncPutData } from "../../../../utils/httpRequests";
import InfoSection from "./info-section/InfoSection";
import RoleSection from "./role-section/RoleSection";
import { useAlertContext } from "../../../../contexts/alert/AlertProvider";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

const schema = yup.object({
  ma_khoa: yup.string().required("Vui lòng nhập mã khoa"),
});

function FormNCSDTHUOC({
  defaultValues,
  isEdit,
  apiCode,
  open,
  freeMode,
  title,
  onClose,
  setLoad,
}: IForm) {
  const { showAlert } = useAlertContext();
  const token = useSelector((state: any) => state.auth.token);
  const defaultData: { [key: string]: any } = {
    ma_khoa: "",
    id_thuoc: "",
    hoat_chat: "",
    ham_luong: "",
    dang_bao_che: "",
    duong_dung: "",
    dvt: "",
    nhom: "",
    du_toan: "",
    sl_sd_trongnam: 0,
    dx_sd_nam0: 0,
    tyle_tt: 0,
    //
    dien_giai: "",
    sl_mua_them_nam0: "",
    dx_sd_nam1: "",
    sl_mua_them_nam1: "",
    dm_thau_dt: "",
    ten_thuoc_da_sd: "",
    ma_noi_bo: "",
    gia_gan_nhat: "",
    he_thuoc: "",
    ma_anh_xa: "",
    note: "",
    // role
    visible_to: "5",
    usergroup: null,
  };
  const originData = !!defaultValues
    ? {
        ...defaultData,
        ...defaultValues,
        usergroup:
          defaultValues?.visible_to_usergroups?.length > 0
            ? defaultValues?.exfields?.visible_to_usergroups?.[0]
            : null,
      }
    : defaultData;
  const {
    control,
    setValue,
    watch,
    register,
    handleSubmit,
    formState: { isSubmitting, errors },
  } = useForm({
    mode: "onSubmit",
    defaultValues: originData,
    resolver: yupResolver(schema),
  });

  const sl_sd_trongnam = watch("sl_sd_trongnam");
  const dx_sd_nam0 = watch("dx_sd_nam0");

  const generateDataPost = (values: typeof defaultData) => {
    const { usergroup, ...fields } = values;
    const result: { [key: string]: any } = { ...fields };
    result.visible_to_usergroups = [usergroup?._id];
    result.exfields = {
      ...defaultValues?.exfields,
      visible_to_usergroups: [usergroup],
    };
    return result;
  };

  const checkValidate = (values: typeof defaultData): boolean => {
    if ((values.tyle_tt || 0) > 30 && !values.dien_giai) {
      showAlert({
        type: "warning",
        message: "Nhập lý do vượt 30% số lượng so với 12 tháng liền kề",
      });
      return false;
    }
    const dx_sd_nam0_30 = ((values.dx_sd_nam0 || 0) * 30) / 100;
    if (values?.sl_mua_them_nam0 > dx_sd_nam0_30) {
      showAlert({
        type: "warning",
        message:
          "Số lượng tùy chọn mua thêm năm thứ nhất vượt quá 30% đề xuất nhu cầu sử dụng cho năm thứ nhất",
      });
      return false;
    }
    const dx_sd_nam1_30 = ((values.dx_sd_nam1 || 0) * 30) / 100;
    if (values?.sl_mua_them_nam1 > dx_sd_nam1_30) {
      showAlert({
        type: "warning",
        message:
          "Số lượng tùy chọn mua thêm năm thứ hai vượt quá 30% đề xuất nhu cầu sử dụng cho năm thứ hai",
      });
      return false;
    }
    return true;
  };

  const handleSave = async (values: typeof defaultData) => {
    const isValid = checkValidate(values);
    if (!isValid) {
      return;
    }
    const dataPost = generateDataPost(values);
    try {
      if (isEdit) {
        await asyncPutData({
          id: defaultValues?._id,
          apiCode,
          token,
          applyToken: true,
          withIdApp: true,
          data: dataPost,
        });
      } else {
        await asyncPostData({
          apiCode,
          token,
          applyToken: true,
          withIdApp: true,
          data: dataPost,
        });
      }
      onClose();
      setLoad?.((prev: number) => prev + 1);
    } catch (error: any) {
      alert(error?.error || error?.message || "Lưu không thành công");
    }
  };

  const onSubmit = handleSubmit(handleSave);

  useEffect(() => {
    const tyLeTt =
      ((dx_sd_nam0 || 0) - (sl_sd_trongnam || 0)) / (sl_sd_trongnam || 1);
    setValue("tyle_tt", tyLeTt);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sl_sd_trongnam, dx_sd_nam0]);

  return (
    <ModalForm
      formWidth="1000px"
      formTitle="nhu cầu sử dụng thuốc"
      title={title}
      open={open}
      onClose={onClose}
      isEdit={isEdit}
      onSubmit={onSubmit}
      loading={isSubmitting}
    >
      <Stack gap={1}>
        <InfoSection register={register} control={control} errors={errors} />
        <RoleSection control={control} watch={watch} />
      </Stack>
    </ModalForm>
  );
}

export default FormNCSDTHUOC;
